export class RegisterRequest {
  public orderIdentifiers:any[]|null;
  constructor(
    public firstname: string,
    public lastname: string,
    public email: string,
    public zipcode: string,
    public password: string,
    public hasSubcribedToEmail: boolean,
    public phoneNumber?: string,
    public confPW?: string,
    public orderId?: number | null,
    public guestUserGuid?: string | null
  ) { }
}

